import React, { Component } from 'react';

//import { DropDownList, AutoComplete, MultiSelect } from "@progress/kendo-react-dropdowns";
//import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
//import DropDownContainer from "../components/DropDownContainer";
//import DatePickerContainer from '../components/DatePickerContainer';
import { /*Grid, */GridColumn as Column } from '@progress/kendo-react-grid';
//import { orderBy } from '@progress/kendo-data-query';
//import { defaultGridProperties, DropDownFilterCell } from '../components/utils/GridHelpers';
//import somLogoMini from '../img/super-cloud-rgb-mini.png';
//import somLogoMini from '../helpers';
import "@progress/kendo-theme-material/dist/all.css";
//import { filterBy } from '@progress/kendo-data-query';
//import PropTypes from "prop-types";
import GridContainer/*, { ToolbeltOption, GridContainerToolbar, GridContainerToolbarOption }*/ from '../components/GridContainer';
import { Dialog } from "@progress/kendo-react-dialogs";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

//import { AppContext } from '../context/AppContext';
//import { Tooltip } from '@progress/kendo-react-tooltip';
//import ReactTooltip from 'react-tooltip';
//import { isEmpty } from '../helpers';

class NumericCell extends React.Component {
    localizedData = [
        { text: 'yes', value: true },
        { text: 'no', value: false },
        { text: '(empty)', value: null }
    ];

    shouldComponentUpdate(nextProps, nextState) {
        // console.log('this.props', this.props)
        // console.log('nextProps', nextProps)

        return true;
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log('componentDidUpdate', 'prevProps:', prevProps, 'this.props', this.props)
    }

    handleChange = (e) => {
        //debugger;

        this.props.onChange({
            dataItem: this.props.dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
        });
    }
    handleClick = (e) => {
        //debugger
        //console.log('this.props.dataItem', this.props.dataItem)
        this.props.dataItem['cost'] = 0;
        //console.log('this.props.dataItem', this.props.dataItem)
        //this.props.onChange
        this.forceUpdate()
    }

    render() {
        const dataValue = this.props.dataItem[this.props.field];
        //console.log('this.props', this.props)


        // if (!this.props.dataItem.inEdit) {
        //     return (
        //         <td>
        //             {(dataValue === null) ? '' : this.props.dataItem[this.props.field].toString()}
        //         </td>
        //     );
        // }

        return (
            <td>
                <Input
                    type="number"
                    style={{ width: "100px" }}
                    onChange={this.handleChange}
                    value={dataValue}
                />
                <span onClick={this.handleClick}>x</span>
            </td>
        )

        // return (
        //     <td>
        //         <DropDownList
        //             style={{ width: "100px" }}
        //             onChange={this.handleChange}
        //             value={this.localizedData.find(c => c.value === dataValue)}
        //             data={this.localizedData}
        //             textField="text"
        //         />
        //     </td>
        // );
    }
}


export default class Test extends Component {

    suggestedOrders;
    constructor(props) {
        super(props);

        this.suggestedOrders = [
            {
                "partNumber": "17025-03A",
                "description": "BREATHER ASSY",
                "quantity": 2,
                "package": false,
                "packageCount": 0,
                "cost": 12.03,
                "total": 24.06,
                "soDate": 20190530
            },
            // {
            //     "partNumber": "17369-06",
            //     "description": "KIT-GASKET,SERV,1K/5K/10K",
            //     "quantity": 1,
            //     "package": true,
            //     "packageCount": 36,
            //     "cost": 133.56,
            //     "total": 133.56,
            //     "soDate": 20190530
            // },
            // {
            //     "partNumber": "24018-10",
            //     "description": "KIT-CAM BEARING ASY,TC96",
            //     "quantity": 1,
            //     "package": false,
            //     "packageCount": 0,
            //     "cost": 19.67,
            //     "total": 19.67,
            //     "soDate": 20190530
            // },
        ]

        this.state = {
            suggestedOrders: this.suggestedOrders.map((point, index) => Object.assign({ inEdit: true, index }, point)),
            neverOrder: false,
            value: 0
        }
    }


    handleChange = (e) => {
        //debugger;
        //const { country } = this.state;
        //country.push(e.target.value);


        if (["neverOrder"].includes(e.target.name)) {
            this.setState({
                [e.target.name]: e.target.checked
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    handleMultiSelectChange = (e) => {

        this.setState({
            country: [...e.target.value]
        });
    }

    onItemChange = (e) => {
        e.dataItem[e.field] = e.value;
        const index = e.dataItem['index'];

        this.setState({
            data: Object.assign([], this.state.data, { [index]: e.dataItem })
        })

        // debugger;
        // console.log('[...this.state.data]', [...this.state.data])

        // // update the state according to the chosen index
        // this.setState({
        //     data: this.state.data
        // })
    }
    handleOrderQuantityChange = (e) => {

        //debugger;
        // dataItem['quantity'] = element.value;

        // // update the order quantity with the tagery
        // this.setState({
        //     suggestedOrders: [...this.state.suggestedOrders]
        // })

        // this.props.onChange({
        //     dataItem: this.props.dataItem,
        //     field: 'quantity',
        //     syntheticEvent: e.syntheticEvent,
        //     value: e.target.value
        // })
    }

    //<li className="option show-excluded-parts">
    //    <input type="checkbox" id="part-exception-never-order" name="neverOrder" checked={this.state.neverOrder} className="apple-switch" onChange={this.handleChange} />
    //    <label className="apple-switch-label" htmlFor="part-exception-never-order">{this.props.returnLocalizedString("m0152")}</label>
    //</li>
    render() {

        //!DBTRANS! @m0152@ Never order this item again !DEVNOTE! Field label
        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0318@ Cost !DEVNOTE! Column label
        //!DBTRANS! @m0426@ Qty !DEVNOTE! Column label
        //!DBTRANS! @m0427@ Session Expiring !DEVNOTE! Text dialog
        //!DBTRANS! @m0428@ Your session is about to expire in under 5 minutes. !DEVNOTE! Text dialog
        //!DBTRANS! @m0429@ Do you want to continue using this application? !DEVNOTE! Text dialog
        //!DBTRANS! @m0430@ End my session !DEVNOTE! Button label
        //!DBTRANS! @m0431@ Continue session !DEVNOTE! Button Label

        return (

            <React.Fragment>
                <NumericTextBox
                    width={90}
                    min={0}
                    name="orderQuantity"
                    onChange={(e) => {
                        this.setState({ 'value': e.target.value })
                    }}
                    value={this.state.value} />
                <div className="grid-toolbar top">
                    <li className="option show-excluded-parts">
                        <label className="ios-switch-label" htmlFor="part-exception-never-order">
                            <input type="checkbox" id="part-exception-never-order" name="neverOrder" checked={this.state.neverOrder} class="ios-switch green tinyswitch" onChange={this.handleChange} />
                            <div><div></div></div>{this.props.returnLocalizedString("m0152")}
                        </label>
                    </li>
                </div>
                <GridContainer
                    data={this.state.suggestedOrders}
                    sortColumn="partNumber"
                    editField="inEdit"
                    onItemChange={this.onItemChange}
                >

                    <Column
                        field="partNumber"
                        title={this.props.returnLocalizedString("m0191")}
                        width="200px"
                        editable={false}
                    />
                    <Column
                        field="description"
                        title={this.props.returnLocalizedString("m0258")}
                        width="250px"
                        editable={false}
                    />
                    <Column
                        field="quantity"
                        headerClassName="numeric"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0426")}
                        width="175px"
                        cell={(props) => {
                            return (
                                <td className="numeric">
                                    <Input type="number"

                                        width={100}
                                        min={0}
                                        name="orderQuantity"
                                        onChange={this.handleOrderQuantityChange(this.props.onChange)}
                                        value={props.dataItem.quantity}
                                    />
                                    <span onClick={(e) => { this.handleOrderQuantityChange(props.dataItem, 0) }} style={{
                                        'cursor': 'pointer'
                                    }}>X</span>
                                </td>
                            )
                        }}
                    />
                    <Column
                        field="cost"
                        headerClassName="numeric"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0318")}
                        width="150px"
                        cell={NumericCell}
                    />


                </GridContainer>
                <Dialog className="confirmation"

                    width={480}
                    height='auto'
                    minWidth={320}
                    closeIcon={false}
                    title={this.props.returnLocalizedString("m0427")}
                    onClose={this.handleCloseModal}
                >
                    <p>{this.props.returnLocalizedString("m0428")}</p>
                    <p>{this.props.returnLocalizedString("m0429")}</p>

                    <DialogActionsBar>
                        <Button
                            className="cancel"
                            onClick={this.handleEndSession}
                        >
                            {this.props.returnLocalizedString("m0430")}
					</Button>
                        <Button className="yes" primary={true}
                            onClick={this.handleRenewSession}
                        >
                            {this.props.returnLocalizedString("m0431")}
					</Button>
                    </DialogActionsBar>
                </Dialog>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Test.js